<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg
    class="icon icon-running-w-shadow"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="12" cy="12" r="3.6" fill="currentColor" />
    </g>
  </BaseSvg>
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
.icon {
  &.icon-running-w-shadow {
    filter: drop-shadow(0 0 8px currentColor);
  }
}
</style>
